import React, { useState, useRef, useEffect } from 'react'

import BillerSelector from 'components/__new/billPayment/BillerSelector';
import { ButtonLoader, Input } from 'components/__new/common/form';
import FormDrawer from 'components/__new/common/form-drawer';
import useLoginInfo from 'hooks/useLoginInfo';
import { REGEX_VALUES } from 'utils/regexValues';


const CreateAirtimeDataBeneficiary = ({ isOpen, createBeneficiaryLoading, toggleCreateBeneficiary, initiateBeneficiaryCreation }) => {
    const searchableBillersRef = useRef();
    const {userInfo} = useLoginInfo();
    

    const [form, setForm] = useState({
        network: {},
        phoneNumber: "",
        alias: "",
    });
    
    const handleNameChange = (e) => {
        const { name, value } = e.target;
        if ((name === "alias") && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
          return;
        }
        setForm({...form, [name]: value})
      }
    
    const handleAccountChange = (e) => {
        const { value } = e.target;
        if ((value.length !== 12) && (value >= 0)) {
            setForm({...form, phoneNumber: value})
        }
    }

    const initateCreation = (e) => {
        e.preventDefault();
    
            const params = {
                phoneNumber: form.phoneNumber,
                alias: form.alias || '-',
                product: form.network?.value,
                service: 'data',
                businessId: userInfo?.employer?._id,
            }
            
            // toggleCreateBeneficiary();
            initiateBeneficiaryCreation(params)
        }
        
    
    const disableSubmit = !form?.network?.label?.length || form?.phoneNumber?.length !== 11;
    
    useEffect(() => {
        setForm({
            network: {},
            phoneNumber: "",
            alias: "",
        })
    }, [])
    
    
    
    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={() => {}}>
            
            <div className='w-full p-6'>
                <FormDrawer.Title
                    close={toggleCreateBeneficiary}
                    showCloseButton={true}
                    title="Add Single Beneficiary"
                    description="Create and add new beneficiaries to your list"
                />
            
                <form onSubmit={initateCreation}>
                    <div className="w-full mt-5">
                        
                        <Input
                            type="text"
                            label="Beneficiary Name"
                            value={form?.alias}
                            className="form-input"
                            placeholder="Enter name"
                            name="alias"
                            onChange={handleNameChange}
                        />
                        
                        <div className="relative">
                            <BillerSelector
                                type="data"
                                label="Biller"
                                tag="networks"
                                ref={searchableBillersRef}
                                onValueChange={(e) => setForm({...form, network: e})}
                            />
                        </div>

                        <div className="form-group relative">
                            <label>Phone Number</label>
                            <input
                                type="number"
                                id="prl-input"
                                className="form-input"
                                value={form.phoneNumber}
                                placeholder="Enter phone number"
                                onChange={handleAccountChange}
                            />
                            
                        </div>
                    </div>
                    
                    <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                        <button type="button" onClick={toggleCreateBeneficiary} className="btn btn-transparent-primary mr-3">
                            Cancel
                        </button>
                        
                        <ButtonLoader type="submit" loading={createBeneficiaryLoading} disabled={disableSubmit} className="btn btn-ep-primary">
                            Add Beneficiary
                        </ButtonLoader>
                    </div>
                </form>
            </div>
        
        </FormDrawer>
    )
}


export default CreateAirtimeDataBeneficiary